import './Main.css';

interface MainProps {
  children?: JSX.Element[] | JSX.Element;
  footer?: JSX.Element;
  className: string;
}

function Main({ children, footer, className }: MainProps): JSX.Element {
  return (
    <div className={`parent ${className}`}>
      <main className="main" aria-live="polite">
        {children}
      </main>
      {footer}
    </div>
  );
}

export default Main;
